export default __webpack_public_path__ + "static/media/total_leads.b3c1633b.png";